import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = 2026;

  const navLinks = [
    { href: '/homepage', label: 'Home' },
    { href: '/services', label: 'Services' },
    { href: '/contact', label: 'Contact Us' },
  ];

  const legalLinks = [
    { href: '#privacy', label: 'Privacy' },
    { href: '#terms', label: 'Terms' },
  ];

  const socialLinks = [
    { href: '#linkedin', icon: 'LinkIcon', label: 'LinkedIn' },
    { href: '#twitter', icon: 'AtSymbolIcon', label: 'Twitter' },
  ];

  return (
    <footer className="bg-black border-t border-border py-8 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] font-bold uppercase tracking-[0.2em]">
        {/* Logo */}
        <Link href="/homepage" className="text-white font-bold text-base tracking-tight uppercase">
          Armada <span className="text-primary">MSP</span>
        </Link>

        {/* Navigation Links */}
        <div className="flex gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              {link.label}
            </Link>
          ))}
          {legalLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Social Icons + Copyright */}
        <div className="flex items-center gap-6">
          {socialLinks.map((social) => (
            <a
              key={social.href}
              href={social.href}
              className="text-muted-foreground hover:text-primary transition-colors"
              aria-label={social.label}
            >
              <Icon name={social.icon as any} size={16} />
            </a>
          ))}
          <span className="text-muted-foreground">
            © {currentYear} Armada MSP
          </span>
        </div>
      </div>
    </footer>
  );
}